import React from 'react'
import gql from 'graphql-tag'
import { useMutation } from 'react-apollo'
import PropTypes from 'prop-types'
import { LocalizedText, PromiseIconAction } from 'labguard-cdk'
import { sidebarGroupsQuery } from 'src/components/App/GroupSidebar'
import { EyeIcon, EyeSlashIcon } from 'src/components/common/icons'

const mutation = gql`
  mutation toggleGroup($id: ID!) {
    toggleGroup(id: $id) {
      id
      hidden
    }
  }
`

const GroupVisibility = ({ group }) => {
  const [toggle] = useMutation(mutation, {
    variables: { id: group.id },
    context: { notify: { success: false, error: true, loading: false } },
    refetchQueries: [{ query: sidebarGroupsQuery }],
  })

  return (
    <PromiseIconAction
      icon={!group.hidden ? EyeIcon : EyeSlashIcon}
      active={!group.hidden}
      tooltip={<LocalizedText id={group.hidden ? 'WEB_SHOW' : 'WEB_HIDE'} />}
      transform="grow-5"
      onClick={toggle}
    />
  )
}

GroupVisibility.propTypes = {
  group: PropTypes.object,
}

export default GroupVisibility
